<div fxLayout="column" fxLayoutAlign="start stretch" class="w-100">
    <div class="t2-semi-bold">{{ label | translate }}</div>
    @for (field of fields; track field) {
        <div fxLayout="row" fxLayoutAlign="start center" class="mt-16 w-100" (click)="field.isExpanded = !field.isExpanded"
             [class.pointer]="field.isExpandable">
            <div class="w-300 t2 c-primary-gray-600"> {{ 'i18n_af_label_field_participant#' + field.fieldName | translate }}</div>
            <div class="ml-16 t2"
                 [class.c-primary-gray-900]="!field.isExpandable"
                 [class.c-primary-green-800]="field.isExpandable">
                {{ field.fieldValue }}
            </div>
            @if (field.isExpandable) {
                <ui-kit-svg class="i-16 expandable ml-8 c-primary-green-800"
                            name="ic_arrow_down"
                            [class.expanded]="field.isExpanded"/>
            }
        </div>
        @if (field.isExpandable && field.expandableValue?.length && field.isExpanded) {
            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                class="nested-info-container w-100">
                @for (fieldExpandable of field.expandableValue; track fieldExpandable) {
                    <div fxLayout="row" fxLayoutAlign="start start" class="mt-8 w-100">
                        @if (hasExpandableChildren(fieldExpandable)) {
                            <div class="ml-16">
                                @for (subField of fieldExpandable.expandableValue; track subField) {
                                    <div fxLayout="row" fxLayoutAlign="start start" class="mt-4">
                                        <div class="w-300 t2 c-primary-gray-600 pre-line">
                                            {{ 'i18n_af_label_field_participant#' + fieldExpandable.fieldName + '_' + subField.fieldName | translate }}
                                        </div>
                                        <div class="ml-16 t2 c-primary-gray-900">
                                            {{ subField.fieldValue }}
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="w-300 t2 c-primary-gray-600 pre-line">
                                {{ 'i18n_af_label_field_participant#' + fieldExpandable.fieldName | translate }}
                            </div>
                            <div class="ml-16 t2 c-primary-gray-900">
                                {{ fieldExpandable.fieldValue }}
                            </div>
                        }
                    </div>
                }
            </div>
        }
    }
</div>
